import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GlobalDashboardComponent } from './global-dashboard/global-dashboard.component';
import { LoginComponent } from './login/login.component';
import { UserMaintenanceComponent } from './user-maintenance/user-maintenance.component';
import { AddUpdateuserComponent } from './add-updateuser/add-updateuser.component';
import { ProjectlistComponent } from './projectlist/projectlist.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { ResourcesComponent } from './resources/resources.component';





const routes: Routes = [
  { path: 'dashboard', component: GlobalDashboardComponent },
  //{ path: 'EmployeeMaintenance', component: UserMaintenanceComponent },
  { path: 'loginuser', component: LoginComponent },
  { path: '', component: LandingpageComponent },
  { path: 'StaffMaintenance', component: AddUpdateuserComponent },
  { path: 'EmployeeMaintenance', component: UserMaintenanceComponent },
  { path: 'ProjectList', component: ProjectlistComponent },
  { path: 'Resources', component: ResourcesComponent }


  // { path: '**', redirectTo: 'dashboard' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
